import type { JiraComment } from '../../types';

export const isJiraComment = (entity: any): entity is JiraComment =>
	entity.__typename === 'JiraComment';

export const getJiraCommentLink = (comment: JiraComment): string | null => comment?.webUrl ?? null;
